import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Subject, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Directive({
  selector: '[appAspectRatio]',
  standalone: true
})
export class AspectRatioDirective implements OnInit, OnDestroy {
  /**
   * Proporcja wysokości do szerokości, np. 9/16 = 0.5625
   */
  @Input('appAspectRatio') ratio = 1;
  @Input('isImage') isImage: boolean = false;

  private resizeObserver?: ResizeObserver;
  private resizeSubject?: Subject<void>;
  private resizeSub?: Subscription;
  private isBrowser: boolean;

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    // SSR: nie robić nic na serwerze
    if (!this.isBrowser) {
      return;
    }

    // Tworzymy Subject do throttlingu wywołań resize
    this.resizeSubject = new Subject<void>();

    // Subskrybujemy z throttleTime, np. co 100ms
    this.resizeSub = this.resizeSubject.pipe(
      throttleTime(100)
    ).subscribe(() => this.updateHeight());

    // Inicjalny pomiar i ustawienie wysokości
    // Używamy requestAnimationFrame, by w 100% mieć wymiary DOM
    requestAnimationFrame(() => this.updateHeight());

    // Inicjalizujemy ResizeObserver
    this.resizeObserver = new ResizeObserver(() => {
      this.resizeSubject!.next();
    });

    this.resizeObserver.observe(this.el.nativeElement);
  }

  private updateHeight(): void {
    const width = this.el.nativeElement.offsetWidth;
    const height = width * this.ratio;
    if (height > 0) {
      this.renderer.setStyle(this.el.nativeElement, 'height', `${height}px`);
    }
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.resizeSub) {
      this.resizeSub.unsubscribe();
    }
    if (this.resizeSubject) {
      this.resizeSubject.complete();
    }
  }
}
